import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onEdit", "onReplace", "onRemove", "onUnlink"];
import { PopoverBodyLiteIcons } from '../../constants/popover';
import { LinkTypes } from '../../constants/link';
import { pick } from '../../utils/iterables';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
//@ts-expect-error untyped module
import LinkPreview from '../links/LinkPreview';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `RichTextLib.image.lite.${key}`;
function ImagePopoverBodyLite(props) {
  const {
      onEdit,
      onReplace,
      onRemove,
      onUnlink
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const iconButtons = [{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.REPLACE,
    onClick: onReplace
  }, {
    iconName: PopoverBodyLiteIcons.REMOVE,
    onClick: onRemove
  }];
  if (props.href) {
    iconButtons.push({
      iconName: PopoverBodyLiteIcons.UNLINK,
      onClick: onUnlink
    });
  }
  return /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
    "data-test-id": "image-popover-body-lite",
    iconButtons: iconButtons,
    i18nKey: i18nKey,
    children: props.href && /*#__PURE__*/_jsx(LinkPreview, Object.assign({}, pick(Object.keys(LinkPreview.propTypes), rest), {
      className: "p-left-3 " + (props.linkType === LinkTypes.ANCHOR ? 'p-right-2' : 'p-right-1'),
      alignSelf: "center"
    }))
  });
}
ImagePopoverBodyLite.displayName = 'ImagePopoverBodyLite';
export default ImagePopoverBodyLite;